import * as React from "react";
import {Box, useTheme} from "@mui/material";
import {styles} from "./NewsStyles";

function ChatWidgetPointer() {
    const theme = useTheme();
    const style = styles(theme);

    return (
        <Box sx={style.pointerContainer}>
            <Box sx={style.pointerRing}/>
        </Box>
    );
}

export default ChatWidgetPointer;
